import { HStack, Text } from '@enechain/ecloud-designsystem'
import { FaTriangleExclamationSolid } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  children: React.ReactNode
}

/**
 * 欄の直下に出す注意文 (design 8080 `admin/occto.html` の `.form-warn-msg`)。
 *
 * **エラー (赤) にしない**: 入力として不正と言い切れない (保存を止めない) 時に使う。
 * したがって `FieldRoot invalid` / `FieldErrorText` は使わず、 form の検証エラーにも
 * しない。 状態を伝える icon なので Solid variant。
 * 欄との間隔は design の 4px ではなく DS `FieldRoot` の gap に任せる
 * (同じ欄に出る `FieldErrorText` と間隔を揃えるため)。
 */
export const FieldWarningText = ({ children }: Props): React.ReactElement => (
  <HStack align="flex-start" gap={1}>
    <FaTriangleExclamationSolid
      flexShrink={0}
      boxSize={iconSize.fieldMessage}
      // design `.form-warn-msg svg { margin-top: 2px }`。 sm (12px) 本文の
      // 1 行目の中心に glyph を合わせる光学補正で、 token に無い値。
      marginTop="2px"
      color="Object.warningMid"
    />
    <Text textStyle="caption" color="Text.warningMid">
      {children}
    </Text>
  </HStack>
)
